import script from "./AwardCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AwardCard.vue?vue&type=script&setup=true&lang=ts"

import "./AwardCard.vue?vue&type=style&index=0&id=896a1602&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-896a1602"]])

export default __exports__